import React from 'react';

import './styles.scss';

interface WidgetProps {
  cardKey: string;
  children?: React.ReactNode | React.ReactNode[];
}

const Widget: React.FC<WidgetProps> = ({ children, cardKey }) => {
  return (
    <div className="general-widget-container" key={cardKey}>
      {children}
    </div>
  );
};

export default Widget;
